if(!customElements.get('slider-hero')) {
  class SliderHero extends HTMLElement {
    constructor() {
      super();

      this.initSlider();
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('[data-slider]'), {
        slidesPerView: 1,
        speed: 1000,
        loop: true,
        autoHeight: true,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        autoplay: this.dataset.autoplay === 'true' ? { delay: this.dataset.speed } : false,
        breakpoints: {
          768: {
            allowTouchMove: this.dataset.drag === 'true' ? true : false
          },
          1024: {
            allowTouchMove: this.dataset.drag === 'true' ? true : false
          },
        },
      });
    }
  }

  customElements.define('slider-hero', SliderHero);
}
